"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Short = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = require("./Title");
require("./Short.scss");
const Short = _ref => {
  let {
    className,
    statuses
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-StatusBarShort', className);
  const activeStatuses = statuses.filter(item => !!item.status);
  const lastStatus = [...activeStatuses].pop();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_Title.Title, {
    activeStatuses: activeStatuses,
    lastStatus: lastStatus
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-StatusBarShort-Steps"
  }, statuses.map((item, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: (0, _key.createKey)(index, 'status'),
    className: (0, _classnames.default)('cds-StatusBarShort-Step', {
      'cds-StatusBarShort-Step--Active': !!item.status
    })
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-StatusBarShort-Counter"
  }, "(", activeStatuses.length, "/", statuses.length, ")")));
};
exports.Short = Short;
//# sourceMappingURL=Short.js.map